export const reportsVo2Tests = {
    namespaced: true,

    state: {
        filter: {
            athletes: [],
            gender: '',
            location: '',
            erg_id: '',
            cpx_device: '',
            protocol: '',
            sweep_scull: '',
            weight_class: '',
            examiner: '',
            tags: [],
            focuses: []
        }
    },

    getters: {
        vo2TestFilter(state) {
            return state.filter;
        }
    },

    mutations: {
        resetFilter(state) {
            state.filter = {
                athletes: [],
                gender: '',
                location: '',
                erg_id: '',
                cpx_device: '',
                protocol: '',
                sweep_scull: '',
                weight_class: '',
                examiner: '',
                tags: [],
                focuses: []
            };
        },

        setFilter(state, filter) {
            state.filter = filter;
        },

        setAthletes(state, athletes) {
            state.filter.athletes = athletes;
        },

        setTags(state, tags) {
            state.filter.tags = tags;
        },

        setFocuses(state, focuses) {
            state.filter.focuses = focuses;
        }
    }
};

export default reportsVo2Tests;
